<template>
  <section id="userIndex">
    <br>
    <v-container fluid>
      <v-row>
  <v-btn
                rounded
                large
                color="success"
                class="accent shadow-4 px-8"
                @click="rangeDialogActive = true;"
                >Buscar reporte</v-btn
              >
  
      </v-row>
    </v-container>
    
    <v-card class="shadow-1 mt-5 mt-md-10">
      <v-data-table
        :headers="headers"
        :items="accumulatedIndicatorsList"
      >
        <template v-slot:[`item.average_service_level_20s`]="{ item }">
          <span>
            {{ item.average_service_level_20s + "%" }}
          </span>
        </template>
        <template v-slot:[`item.efficiency`]="{ item }">
          <span>
            {{ item.efficiency + "%" }}
          </span>
        </template>
      </v-data-table>
    </v-card>

    <!-- MODAL DE RANGO DE FECHA -->
    <RangeDateDialog
      v-if="rangeDialogActive"
      :active="rangeDialogActive"
      module="accumulatedIndicators"
      @dialog:change="eventdialog"
    ></RangeDateDialog>
  </section>
</template>

<script>
import { PbxHttpClient } from "@/services/httpclient";
import vuescroll from "vuescroll";
import RangeDateDialog from "@/components/DatePickers/DateRangePicker";

export default {
  components: { vuescroll, RangeDateDialog },

  data() {
    return {
      isLoading: true,
      isLoadingDialog: false,
      rangeDialogActive: true,
      // active: true,
      dateRangeMenu: false,
      noDataSelected: false,
      payload: { type: null },
      dates: [],
      accumulatedIndicatorsList: [],
      headers: [
        {
          text: "Fecha",
          align: "left",
          value: "fecha",
          class: "primary--text",
          width: "15%",
        },
        {
          text: "Recibidas",
          align: "left",
          value: "llamadas_recibidas",
          class: "primary--text",
          width: "15%",
        },
        {
          text: "Espera promedio",
          value: "espera_promedio",
          class: "primary--text",
          width: "20%",
        },
        {
          text: "Contestadas",
          value: "contestadas",
          class: "primary--text",
          width: "15%",
        },
        {
          text: "Nivel de servicio",
          value: "average_service_level_20s",
          class: "primary--text",
          width: "15%",
        },
        {
          text: "Eficacia",
          value: "efficiency",
          class: "primary--text",
          align: "center",
          width: "10%",
        },
        {
          text: "Tiempo ACD",
          value: "tiempo_acd",
          class: "primary--text",
          width: "10%",
        },
        {
          text: "Promedio de conversación",
          value: "average_conversation",
          class: "primary--text",
          width: "10%",
        },
        {
          text: "% de ocupación",
          value: "porcentaje_ocupacion",
          class: "primary--text",
          width: "15%",
          align: "left",
          sortable: false,
        },
        {
          text: "Promedio de documentación",
          value: "promedio_documentacion",
          class: "primary--text",
          width: "15%"
        },
        {
          text: "Recibidas abandonadas",
          align: "left",
          value: "recibida_abandon_6",
          class: "primary--text",
          width: "15%",
        },
         {
          text: "Tráfico de referencia",
          value: "trafico_de_referencia",
          class: "primary--text",
          width: "10%",
        },
      ],
    };
  },

  computed: {
    isMobile() {
      return this.$vuetify.breakpoint.mobile;
    },
    isDark() {
      return this.$vuetify.theme.dark;
    },
  },

  methods: {
    async eventdialog(action, request) {
      // this.active = false;
      this.rangeDialogActive = false;

      if (action !== "cerrar") {
        this.isLoading = true;
        try {
          const { data } = await PbxHttpClient.post(
            `/reports/tail_new`,
            request
          );

          this.accumulatedIndicatorsList = data.daily;

          this.$store.commit("layout/SET_OVERLAY", {
            value: false,
            title: "",
          });
          
        } catch (err) {
          console.log(err);
        }
        this.isLoading = false;
      }
    },
  },
};
</script>

<style>
.shadow-1 {
  -webkit-box-shadow: 0 8px 16px 0 rgba(40, 40, 90, 0.09),
    0 3px 6px 0 rgba(0, 0, 0, 0.065);
  box-shadow: 0 8px 16px 0 rgba(40, 40, 90, 0.09), 0 3px 6px 0 rgba(0, 0, 0, 0.065);
}
.selectionActive {
  color: #fff !important;
  background: #008ffb !important;
  border: 1px solid blue !important;
  border-bottom: 2px solid blue !important;
}
.selectionbtn {
  background: #fff;
  color: #222;
  border: 1px solid #e7e7e7;
  border-bottom: 2px solid #ddd;
  border-radius: 2px;
  padding: 4px 17px;
}
</style>
